import { isValidString } from '../utils/string'
import { objectContainsText } from '../utils/fulltext-search'

/**
 * Filter given object by given search string.
 * Checks if the search string can be found in any of the given
 * search properties of the object to be tested.
 *
 * @param {string} searchString - The current search string
 * @param {string[]} searchProperties - The object properties which should be searched
 * @param {Object} objectToTest - object to be tested
 * @returns {boolean} Whether to include or exclude the Object in the search result
 */
export function filterBySearchString(searchString, searchProperties, objectToTest) {
    if (!isValidString(searchString)) {
        return true
    }

    return objectContainsText(objectToTest, searchString.trim(), searchProperties || [])
}
